import { render, staticRenderFns } from "./AppTopNavigation.vue?vue&type=template&id=1223e2e7&scoped=true"
import script from "./AppTopNavigation.vue?vue&type=script&lang=js"
export * from "./AppTopNavigation.vue?vue&type=script&lang=js"
import style0 from "./AppTopNavigation.vue?vue&type=style&index=0&id=1223e2e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1223e2e7",
  null
  
)

export default component.exports